import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import { Outlet } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';

interface Props {
  isDrawerOpen: boolean;
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>;
  signOut: () => void;
}

export const Layout = ({ isDrawerOpen, setIsDrawerOpen, signOut }: Props) => {
  return (
    <>
      <Navbar signOut={signOut} setIsDrawerOpen={setIsDrawerOpen} />
      <Sidebar setIsDrawerOpen={setIsDrawerOpen} isDrawerOpen={isDrawerOpen} />
      <Outlet />
    </>
  );
};
